import { isInUrlsList } from '@vpfa/utils';

export function isInBlackList(url: string): boolean {
  return isInUrlsList(url, blackList);
}

const blackList: string[] = ['api/Auth', 'api/auth/logout'];
